var render = function render(){var _vm=this,_c=_vm._self._c;return _c('eip-list',{attrs:{"hiddenColumns":['associate_name', 'account'],"id":_vm.id,"showSearchbox":false,"getParams":_vm.getParams,"show-create-action":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }